import { combineReducers } from 'redux'
import authReducer from './authSlice.js'
import dashboardReducer from './dashboardSlice.js'
import propertyReducer from './propertySlice.js'
import userReducer from './userSlice.js'
import notificationReducer from './notificationsSlice.js'
import activityReducer from './activitySlice.js'
import agentReducer from './agentSlice.js'
import messageReducer from './messageSlice.js'
import chatReducer from './chatSlice.js'
import customerReducer from './customerSlice.js'
import uiReducer from './uiSlice.js'
import analyticsReducer from './analyticsSlice.js'
import reportsReducer from './reportsSlice.js'
import reviewReducer from './reviewSlice.js'
import surveyReducer from './surveySlice.js'
import helpReducer from './helpSlice.js'
import feedbackReducer from './feedbackSlice.js'
import sessionReducer from './sessionSlice.js'
const rootReducer = combineReducers({
  auth: authReducer,
  analytics: analyticsReducer,
  ui: uiReducer,
  dashboard: dashboardReducer,
  property: propertyReducer,
  user: userReducer,
  notifications: notificationReducer,
  agent: agentReducer,
  customer: customerReducer,
  activity: activityReducer,
  reports: reportsReducer,
  reviews: reviewReducer,
  surveys: surveyReducer,
  help: helpReducer,
  message: messageReducer,
  chat: chatReducer,
  feedback: feedbackReducer,
  session: sessionReducer,
})

export default rootReducer
